import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AccessRightEnum } from 'projects/bo/src/app/shared/enums/access-right.enum';
import { MenuState } from '../services/states/menu.service';

export const accessRightGuardConfig = (accessRights: AccessRightEnum[], customData: any = {}): any => ({
  canActivate: [AccessRightGuard],
  data: {
    ...customData,
    accessRightGuard: accessRights
  }
});

@Injectable({
  providedIn: 'root'
})
export class AccessRightGuard {
  private readonly router = inject(Router);
  private readonly menuState = inject(MenuState);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentPageUrl = state.url;
    const pageAccessRights = route.data?.['accessRightGuard'] as AccessRightEnum[];

    if (!Array.isArray(pageAccessRights) || !pageAccessRights?.length) {
      throw Error(`Missing accessRightGuard in routing module's data`);
    }

    if (!this.menuState.hasPermissionWithUrl(currentPageUrl, pageAccessRights)) {
      this.router.navigate(['/exception/403']);
      return false;
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
